


export const apiUrl =
{
    createUser: 'http://localhost:5000/api/user/register',
    getAllUser: 'http://localhost:5000/api/user/all-users',
    getUser: "http://localhost:5000/api/user",
    login: "http://localhost:5000/api/user/login",

    category: {
        allCategoryList: 'https://dummyjson.com/products/categories',
        getCategory: 'https://dummyjson.com/products/category'
    },
    product: {
        productList: 'https://dummyjson.com/products',
        singleProduct: 'https://dummyjson.com/products'
    }
}